<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent width="auto">
            <v-card>
                <v-card-title class="titulo">
                    {{ titulo }}
                </v-card-title>
                <v-card-text class="mt-2">
                    <span class="text-info1">{{ textInfo1 }}</span><br>
                    <span class="text-info2">{{ textInfo2 }}</span>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="#124D91" float="left" text class="btn-link" @click="close">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="btn-modalOkCancel" color="primary" @click=" close(); $emit('actionOk')">{{
                        btnOk
                    }}</v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
  
<script>
export default {
    name: 'OkCancelDialog',
    props: ['btnOk', 'textInfo1', 'textInfo2', 'titulo'],
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        open() {
            this.dialog = true
        },
        close() {
            this.dialog = false
        }
    }
}

</script>
<style>
.titulo,
.text-info2 {
    font-family: Inter;
    letter-spacing: 0;
}

.titulo {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
}

.text-info1,
.text-info2 {
    color: #171717;
    font-size: 16px;
    font-weight: 400;
}

.text-info1 {
    line-height: 21.6px;
}
</style>